export const GET_STATUS = 'GET_STATUS'
